import axiosInstance from "@/axios/axiosInstance";
import { LoginCredentials } from "@/interface/auth.types";

export const loginUser = async (data: LoginCredentials) => {
  try {
    const payload = {
      email: data.username,
      password: data.password,
    };
    const response = await axiosInstance.post(`/auth/login`, payload);
    return response?.data?.data;
  } catch (error) {
    throw error;
  }
};

export const getProfile = async () => {
  try {
    const response = await axiosInstance.get("/profile");
    return response?.data?.data;
  } catch (error) {
    throw error;
  }
};
